import { render, staticRenderFns } from "./Panellist.vue?vue&type=template&id=5afb1308&"
import script from "./Panellist.vue?vue&type=script&lang=js&"
export * from "./Panellist.vue?vue&type=script&lang=js&"
import style0 from "./Panellist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports